import { useCallback, useEffect, useState } from 'react';
import { AsyncThunkAction } from '@reduxjs/toolkit';
import { defaultTablePreferances, PreferancesDatasProps } from '../types';
import { TablePreferances } from '@wajeez-web/core/api';
import { useAppDispatch } from '@wajeez-web/stores/base';
import { Identity } from '@wajeez-web/core/api-base';
import { ContentEntityActions } from '@wajeez-web/stores/content';
import { environment } from '@wajeez-web/core/utils';
import { useSearchParams } from 'react-router-dom';

const HandleTableData = (
  tableName: string,
  // eslint-disable-next-line @typescript-eslint/ban-types
  getDataAction: (arg: any) => AsyncThunkAction<any, any, {}>,
  defaultFilters?: Identity.FilteringOperationOfInteger[],
  extraInput?: { [key: string]: any },
  defaultSort?: Identity.SortingOperationOfInteger[],
  defaultPageNumber?: number,
  languageId?: number
) => {
  const [searchParams] = useSearchParams();

  const pageSearchParam = searchParams.get('page');
  const pageSizeSearchParam = searchParams.get('pageSize');

  const dispatch = useAppDispatch();

  const [isTableReferencesLoading, setIsTableReferencesLoading] =
    useState(false);
  const [tablePreferances, setTablePreferences] =
    useState<PreferancesDatasProps | null>(null);

  const getData = () => {
    dispatch(
      getDataAction(
        tablePreferances
          ? {
              ...tablePreferances,
              languageId,
            }
          : { ...defaultTablePreferances, languageId }
      )
    );
  };

  const getTablePreFerances = useCallback(async () => {
    try {
      setIsTableReferencesLoading(true);

      const res = await TablePreferances.getTablePreferancesByNane(tableName);

      const preferance = res?.length
        ? res[res.length - 1]
        : defaultTablePreferances;

      setTablePreferences({
        sortingOperations:
          preferance.sortingOperations?.concat(defaultSort || []) || [],
        filteringOperations:
          preferance.filteringOperations?.concat(defaultFilters || []) || [],
        flags: preferance.flags || 0,
        pageNumber:
          defaultPageNumber || (pageSearchParam ? Number(pageSearchParam) : 1),
        pageSize: pageSizeSearchParam ? Number(pageSizeSearchParam) : 10,
        ...extraInput,
      });

      setIsTableReferencesLoading(false);
      // eslint-disable-next-line no-empty
    } catch (error) {}
  }, [pageSearchParam, pageSizeSearchParam]);

  useEffect(() => {
    if (!tablePreferances) {
      getTablePreFerances();
    } else {
      getData();
    }
  }, [tablePreferances, languageId]);

  return {
    tablePreferances,
    setTablePreferences,
    getData,
    isTableReferencesLoading,
  };
};

export default HandleTableData;
